var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { flattenCategories } from './flatten-categories';
export function getPreExpandedCategories(_a) {
    var categoryIds = _a.categoryIds, categories = _a.categories;
    var initialCategories = {
        level1: null,
        level2: null,
    };
    if (!categories || !categories.length || !categoryIds || !categoryIds.length) {
        return initialCategories;
    }
    var flattenedCategories = flattenCategories(categories);
    var foundCategories = categoryIds.reduce(function (result, categoryId) {
        var foundCategory = flattenedCategories[categoryId];
        return foundCategory ? __spreadArray(__spreadArray([], result, true), [foundCategory], false) : result;
    }, []);
    if (!foundCategories || !foundCategories.length) {
        return initialCategories;
    }
    var highestLevelSelectedCategory = foundCategories.reduce(function (highestLevelCategory, category) {
        return category.level > highestLevelCategory.level ? category : highestLevelCategory;
    }, foundCategories[0]);
    var currentCategory = highestLevelSelectedCategory;
    var nextResult = {
        level1: null,
        level2: null,
    };
    if (highestLevelSelectedCategory.level === 1) {
        return __assign(__assign({}, nextResult), { level1: highestLevelSelectedCategory.id });
    }
    if (highestLevelSelectedCategory.level === 2) {
        return __assign(__assign({}, nextResult), { level1: highestLevelSelectedCategory.parentId, level2: highestLevelSelectedCategory.id });
    }
    while (currentCategory.level !== 1) {
        if (currentCategory.level === 2) {
            nextResult.level2 = currentCategory.id;
        }
        var parentCategory = flattenedCategories[currentCategory.parentId];
        if (!parentCategory) {
            break;
        }
        currentCategory = parentCategory;
    }
    if (currentCategory.level === 1) {
        nextResult.level1 = currentCategory.id;
    }
    return nextResult;
}
